import { Card, CardContent } from "@geely/ui";
import { Loader2 } from 'lucide-react';
import { AdminLayout } from '@/app/components/AdminLayout';
import { MetricsCards, DateFilter, StoreAgenda } from './components';
import { useDashboardData } from './hooks';

export function DashboardPage() {
  const {
    user,
    isStoreAdmin,
    userStore,
    isLoading,
    availableDates,
    selectedDate,
    setSelectedDate,
    filteredAppointments,
    metrics,
    timeSlots,
    maxParallelAppointments,
  } = useDashboardData();

  if (isLoading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="size-8 animate-spin text-primary" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Dashboard</h2>
          <p className="text-gray-600 mt-1 text-sm sm:text-base">
            {isStoreAdmin
              ? `Loja: ${userStore?.name || 'Carregando...'}`
              : 'Visão geral do sistema'
            }
          </p>
        </div>

        {/* Date Filter */}
        <DateFilter
          selectedDate={selectedDate}
          availableDates={availableDates}
          onDateChange={setSelectedDate}
        />

        {/* Metrics Cards */}
        <MetricsCards metrics={metrics} />

        {/* Store Agenda - only for store_admin */}
        {isStoreAdmin && (
          <StoreAgenda
            timeSlots={timeSlots}
            appointments={filteredAppointments}
            maxParallelAppointments={maxParallelAppointments}
            selectedDate={selectedDate}
          />
        )}

        {/* Admin info card */}
        {user?.role === 'admin' && (
          <Card>
            <CardContent className="pt-6">
              <div className="text-center text-gray-500">
                Como administrador geral, você pode gerenciar lojas e usuários através do menu lateral.
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </AdminLayout>
  );
}
